import {Link as RouterLink} from 'react-router-dom';
import {Link} from '@mui/material';

import {ROUTE__ORDER_FULL_INFO} from '@shared/constants';

const EMPTY_VALUE = '—';

interface Props {
  eventId: string;
  orderId: string;
}

// Orders are identified the same way everywhere: event + last 6 chars of the ID
export const OrderRefLink = ({eventId, orderId}: Props) =>
  orderId ? (
    <Link
      component={RouterLink}
      to={ROUTE__ORDER_FULL_INFO.replace(':id', orderId)}
      underline="hover"
    >
      {`${eventId}-${orderId.slice(-6)}`}
    </Link>
  ) : (
    <>{EMPTY_VALUE}</>
  );
